import {useEffect, useRef} from 'react'

function preloadImage (src) {
    return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = function() {
            resolve(img)
        }
        img.onerror = img.onabort = function() {
            reject(src)
        }
        img.src = src
    })
}

async function loadBatchesSequentially(batches, preloadedRef) {
    for (const batch of batches) {
        for (const imageUrl of batch) {
            if (!preloadedRef.current[imageUrl]) {
                try {
                    const img = await preloadImage(imageUrl);
                    preloadedRef.current[imageUrl] = img;
                } catch {
                    preloadedRef.current[imageUrl] = null;
                }
            }
        }
    }
}

export function useImagePreloader(batches) {
    const preloadedRef = useRef({});

    useEffect(() => {
        if (batches.length) {
            loadBatchesSequentially(batches, preloadedRef);
        }
    }, [batches]);
}